import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailers-retailer_select_custom_option-click';

/**
 * This event will fire when user select and complete a custom option from dropdown
 */
export function trackRetailersRetailerSelectCustomOptionClick(
  custom_option: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { custom_option },
  });
}
